import { GuideTour, UserGuideTour } from '@/types/guideTour';

import { api } from './api';

export const guideTourApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPageGuideTour: builder.query<GuideTour[], { feature: string }>({
      query: (params) => ({
        url: `/v2/guide_tour/onboarding-steps`,
        params,
      }),
    }),
    createPageGuideTour: builder.mutation<GuideTour, { data: Partial<GuideTour> }>({
      query: ({ data }) => ({
        url: `/v2/guide_tour/onboarding-steps`,
        method: 'POST',
        body: data,
      }),
    }),
    getPageGuideTourDetails: builder.query<GuideTour, { id: string }>({
      query: (id) => ({
        url: `/v2/guide_tour/onboarding-steps/${id}`,
      }),
    }),
    updatePageGuideTour: builder.mutation<GuideTour, { id: string; data: Partial<GuideTour> }>({
      query: ({ id, data }) => ({
        url: `/v2/guide_tour/onboarding-steps/${id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    deletePageGuideTour: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `/v2/guide_tour/onboarding-steps/${id}`,
        method: 'DELETE',
      }),
    }),
    // роуты прогресса прохождения тура каждым пользователем
    getUserGuideTour: builder.query<UserGuideTour[], { user_id: string; feature: string }>({
      query: (params) => ({
        url: `/v2/guide_tour/user-onboarding`,
        params,
      }),
    }),
    createUserGuideTour: builder.mutation<UserGuideTour, { data: Partial<UserGuideTour> }>({
      query: ({ data }) => ({
        url: `/v2/guide_tour/user-onboarding`,
        method: 'POST',
        body: data,
      }),
    }),
    getUserGuideTourDetails: builder.query<UserGuideTour, { id: string }>({
      query: (id) => ({
        url: `/v2/guide_tour/user-onboarding/${id}`,
      }),
    }),
    updateUserPageGuideTour: builder.mutation<
      UserGuideTour,
      { id: string; data: { is_complete: boolean } }
    >({
      query: ({ id, data }) => ({
        url: `/v2/guide_tour/user-onboarding/${id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    deleteUserGuideTour: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `/v2/guide_tour/user-onboarding/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetPageGuideTourQuery,
  useCreatePageGuideTourMutation,
  useGetPageGuideTourDetailsQuery,
  useUpdatePageGuideTourMutation,
  useDeletePageGuideTourMutation,
  useGetUserGuideTourQuery,
  useCreateUserGuideTourMutation,
  useGetUserGuideTourDetailsQuery,
  useUpdateUserPageGuideTourMutation,
  useDeleteUserGuideTourMutation,
} = guideTourApi;
